import React from "react";
import {NavLink as Links, Route, Switch, useRouteMatch,} from "react-router-dom";
import Error404 from "../../Components/Error404";
import Dispatch from "../../Module/Booking/Dispatch";
import NewBooking from "../../Module/Booking/NewBooking";
import PendingBooking from "../../Module/Booking/PendingBooking";

function POSBooking() {
  const { url } = useRouteMatch();
  return (
    <>
      <header className="header">
        <div className="header-action bg-white">
          <nav className="nav tabs-left">
            <Links className="nav-link" activeClassName="active" to={url}>
              New Booking
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={url + `/PendingBooking`}
            >
              Pending
            </Links>
            <Links
              className="nav-link"
              activeClassName="active"
              to={url + `/DispatchBooking`}
            >
              Dispatch
            </Links>
          </nav>
        </div>
      </header>
      <Switch>
        <Route path={url} exact component={NewBooking} />
        <Route
          path={url + `/PendingBooking`}
          exact
          component={PendingBooking}
        />
        <Route path={url + `/DispatchBooking/`} exact component={Dispatch} />
        <Route path="*">
          <Error404 />
        </Route>
      </Switch>
    </>
  );
}
export default POSBooking;
